import React from "react";
import DataTable from "react-data-table-component";

const columns = [

{ name:"Designer", selector:(row:any)=>row.name },
{ name:"Cases", selector:(row:any)=>row.cases },
{ name:"Completed", selector:(row:any)=>row.completed },
{ name:"Avg Time", selector:(row:any)=>row.time }

];

const data = [

{ name:"Rahul", cases:40, completed:35, time:22 },
{ name:"Neha", cases:38, completed:34, time:28 },
{ name:"Aman", cases:45, completed:40, time:25 },
{ name:"Priya", cases:30, completed:28, time:26 }

];

const DesignerTable = () => (

<div className="card shadow-sm">

<div className="card-body">

<h5>Designer Performance</h5>

<DataTable
columns={columns}
data={data}
pagination
highlightOnHover
/>

</div>

</div>

);

export default DesignerTable